import { render, staticRenderFns } from "./CustomerBasicDetails.vue?vue&type=template&id=c9fc77ba&scoped=true"
import script from "./CustomerBasicDetails.vue?vue&type=script&lang=js"
export * from "./CustomerBasicDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerBasicDetails.vue?vue&type=style&index=0&id=c9fc77ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fc77ba",
  null
  
)

export default component.exports